<template>
	<Card :title="event.title" :subtitle="event.subtitle" :image="event.image" has-image>
		<template #badges>
			<Badge :color="Color.TrueAArEII" active>#{{ enrollment.id }}</Badge>
			<Badge :color="getEnrollmentStatusColor(enrollment.status)" active>
				{{ trans(`enrollments.status.${enrollment.status}.title`) }}
				<span v-if="enrollment.honored">{{ trans('enrollments.honored') }}</span>
			</Badge>
		</template>
		<Link v-if="pendingPurchaseOrder" :as="PrimaryButton" :color="Color.Amber" :href="route('events.enrollments.purchase-orders.show', [enrollment.id, pendingPurchaseOrder.id])">
			<i class="fa-solid fa-receipt mr-2"/>
			{{ trans('enrollments.purchase-orders.unpaid') }}
		</Link>
		<List>
			<ListItem :title="trans('enrollments.created_at')" :subtitle="enrollment.first_updated"/>
			<ListItem :title="trans('enrollments.updated_at')" :subtitle="enrollment.last_updated"/>
		</List>
	</Card>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Card from '@/Components/Cards/Card.vue'
import {defineProps, type Ref, ref} from 'vue'
import List from '@/Components/Lists/List.vue'
import {type Event} from '@/Types/Events/Event'
import Badge from '@/Components/Badges/Badge.vue'
import ListItem from '@/Components/Lists/ListItem.vue'
import PrimaryButton from '@/Components/Buttons/PrimaryButton.vue'
import {type Enrollment} from '@/Types/Events/Enrollments/Enrollment'
import {getEnrollmentStatusColor} from '@/Helpers/Events/Enrollments/status'
import {type PurchaseOrder} from '@/Types/Events/Enrollments/PurchaseOrders/PurchaseOrder'

const props = defineProps<{
	event:Event,
	enrollment:Enrollment,
	pendingPurchaseOrder?:PurchaseOrder,
}>()

const event:Ref<Event> = ref(props.event)
const enrollment:Ref<Enrollment> = ref(props.enrollment)
</script>